import { render, staticRenderFns } from "./ChemUCI1LDFS2IL2.vue?vue&type=template&id=54f9554b&scoped=true&"
import script from "./ChemUCI1LDFS2IL2.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LDFS2IL2.vue?vue&type=script&lang=js&"
import style0 from "./ChemUCI1LDFS2IL2.vue?vue&type=style&index=0&id=54f9554b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9554b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
